var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useCallback, useRef } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import api from '@/shared/api';
import config from '@/config';
import AuthService, { privileges, functionalities } from '@/shared/services/AuthService';
import SignalRService from '@/shared/services/SignalRService';
import DocumentService from '@/shared/services/DocumentService';
import ToastrService from '@/shared/services/ToastrService';
import handleHttpError from '@/shared/services/HandleHttpError';
import FileUpload from '@/shared/components/input/FileUpload';
import FileIcon from '@/shared/components/FileIcon';
import DocumentDetailsModal from '@/modules/documents/details/DocumentDetailsModal';
import DocumentSelectorModal from '@/shared/components/DocumentSelectorModal';
import FormattedDateShort from '@/shared/components/FormattedDateShort';
import FormattedListValue from '@/shared/components/FormattedListValue';
import Button from '@/shared/components/Button';
import YesNoCancelModal from '@/shared/components/YesNoCancelModal';
import { FaRegFolderOpen } from 'react-icons/fa';
import { CanCreate, CanDelete, CanUpdate } from '@/shared/components/security';
import EditableDocumentTypeSelect from '@/modules/documents/EditableDocumentTypeSelect';
var messages = defineMessages({
    Documents: { id: 'Documents', defaultMessage: 'Documents' },
    AddDocument: { id: 'AddDocument', defaultMessage: 'Add document' },
    DragDropFiles: { id: 'DragDropFiles', defaultMessage: 'Drag & drop files here or' },
    Delete: { id: 'Delete', defaultMessage: 'Delete' },
    DocumentDate: { id: 'DocumentDate', defaultMessage: 'Document date' },
    DocumentType: { id: 'DocumentType', defaultMessage: 'Document type' },
    Name: { id: 'Name', defaultMessage: 'Name' },
    OpenDocument: { id: 'OpenDocument', defaultMessage: 'Open document' },
    ChooseDocumentInAdminPulse: {
        id: 'ChooseDocumentInAdminPulse',
        defaultMessage: 'Choose document in AdminPulse',
    },
    ConfirmDeleteTitle: { id: 'comfirmDeleteTitle', defaultMessage: 'Delete?' },
    ConfirmDeleteDocumentOrLink: {
        id: 'msgConfirmDeleteDocumentOrLink',
        defaultMessage: 'Do you want to delete the document (choose yes) or keep the document in DMS but remove the link (choose no)',
    },
    DeleteDocument: { id: 'DeleteDocument', defaultMessage: 'Delete document' },
    RemoveLink: { id: 'RemoveLink', defaultMessage: 'Remove link' },
    UploadFailed: { id: 'MsgUploadAttachmentFailed', defaultMessage: 'Upload failed' },
    ExtractDocumentData: { id: 'ExtractDocumentData', defaultMessage: 'Extract data (AI)' },
});
var FiscalDocumentList = function (_a) {
    var relationId = _a.relationId, linkType = _a.linkType, linkId = _a.linkId, documents = _a.documents, onDocumentsChanged = _a.onDocumentsChanged, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b, uploadNewDocumentsRef = _a.uploadNewDocumentsRef, onExtractDocument = _a.onExtractDocument, extractingDocumentId = _a.extractingDocumentId;
    var intl = useIntl();
    var _c = useState([]), newDocuments = _c[0], setNewDocuments = _c[1];
    var _d = useState(null), previewDocumentId = _d[0], setPreviewDocumentId = _d[1];
    var _e = useState(false), showDocumentSelector = _e[0], setShowDocumentSelector = _e[1];
    var _f = useState(null), deleteTarget = _f[0], setDeleteTarget = _f[1];
    var newDocumentsRef = useRef(newDocuments);
    newDocumentsRef.current = newDocuments;
    var canReadDocs = AuthService.hasPermission({
        functionality: 'Documents',
        privilege: privileges.Read,
    });
    var canExtractAI = !!onExtractDocument &&
        AuthService.hasFeature('AI') &&
        AuthService.hasPermission({ functionality: functionalities.AI, privilege: privileges.Update });
    useEffect(function () {
        var handler = function (updatedDoc) {
            if (!updatedDoc)
                return;
            var idx = documents.findIndex(function (x) { return x.id === updatedDoc.id; });
            if (idx >= 0) {
                var updated = documents.map(function (x) { return (x.id === updatedDoc.id ? __assign(__assign({}, x), updatedDoc) : x); });
                onDocumentsChanged(updated);
                return;
            }
            var newIdx = newDocumentsRef.current.findIndex(function (x) { return x.id === updatedDoc.id; });
            if (newIdx >= 0) {
                setNewDocuments(function (prev) {
                    return prev.map(function (x) { return (x.id === updatedDoc.id ? __assign(__assign({}, x), updatedDoc) : x); });
                });
            }
        };
        SignalRService.subscribe('documentUpdated', handler);
        return function () { return SignalRService.unsubscribe('documentUpdated', handler); };
    }, [documents, onDocumentsChanged]);
    var linkStagedDocuments = useCallback(function (targetLinkId) { return __awaiter(void 0, void 0, void 0, function () {
        var pending, documentLinks, linkedDocs, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    pending = newDocumentsRef.current;
                    if (!pending || pending.length === 0)
                        return [2 /*return*/, []];
                    documentLinks = pending.map(function (doc) { return ({
                        documentId: doc.id,
                        linkId: targetLinkId,
                        linkType: linkType,
                    }); });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, api.base.post("".concat(config.appUrls.documents, "/api/documents/linksmultiple"), documentLinks)];
                case 2:
                    _a.sent();
                    linkedDocs = __spreadArray([], pending, true);
                    setNewDocuments([]);
                    return [2 /*return*/, linkedDocs];
                case 3:
                    error_1 = _a.sent();
                    handleHttpError(intl)(error_1);
                    return [2 /*return*/, []];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [intl, linkType]);
    useEffect(function () {
        if (uploadNewDocumentsRef) {
            uploadNewDocumentsRef.current = linkStagedDocuments;
        }
    }, [uploadNewDocumentsRef, linkStagedDocuments]);
    var handleFileUploaded = function (error, file) {
        if (error) {
            ToastrService.error(intl.formatMessage(messages.UploadFailed));
            return;
        }
        if (linkId) {
            onDocumentsChanged(__spreadArray(__spreadArray([], documents, true), [file], false));
        }
        else {
            setNewDocuments(function (prev) { return __spreadArray(__spreadArray([], prev, true), [file], false); });
        }
    };
    var handleDeleteExistingDocument = function (doc, deleteDocument) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    if (!deleteDocument) return [3 /*break*/, 2];
                    return [4 /*yield*/, api.base.delete("".concat(config.appUrls.documents, "/api/documents/").concat(doc.id))];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    if (!linkId) return [3 /*break*/, 4];
                    return [4 /*yield*/, api.base.delete("".concat(config.appUrls.documents, "/api/documents/Links/").concat(doc.id, "/").concat(linkId, "/").concat(linkType))];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    onDocumentsChanged(documents.filter(function (x) { return x.id !== doc.id; }));
                    ToastrService.success();
                    return [3 /*break*/, 6];
                case 5:
                    error_2 = _a.sent();
                    handleHttpError(intl)(error_2);
                    return [3 /*break*/, 6];
                case 6:
                    setDeleteTarget(null);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteNewDocument = function (doc) {
        setNewDocuments(function (prev) { return prev.filter(function (x) { return x !== doc; }); });
    };
    var handleDocumentsSelected = function (selectedDocs) {
        setShowDocumentSelector(false);
        if (!selectedDocs || selectedDocs.length === 0)
            return;
        var existingIds = documents.map(function (x) { return x.id; });
        var newDocIds = newDocuments.map(function (x) { return x.id; });
        var genuinelyNew = selectedDocs.filter(function (x) { return !existingIds.includes(x.id) && !newDocIds.includes(x.id); });
        if (genuinelyNew.length === 0)
            return;
        if (linkId) {
            var documentLinks = genuinelyNew.map(function (doc) { return ({
                documentId: doc.id,
                linkId: linkId,
                linkType: linkType,
            }); });
            api.base
                .post("".concat(config.appUrls.documents, "/api/documents/linksmultiple"), documentLinks)
                .then(function () {
                onDocumentsChanged(__spreadArray(__spreadArray([], documents, true), genuinelyNew, true));
            })
                .catch(handleHttpError(intl));
        }
        else {
            setNewDocuments(function (prev) { return __spreadArray(__spreadArray([], prev, true), genuinelyNew, true); });
        }
    };
    var handleDocumentPreviewSaved = function (doc) {
        setPreviewDocumentId(null);
        onDocumentsChanged(documents.map(function (x) { return (x.id === doc.id ? __assign(__assign({}, x), doc) : x); }));
    };
    var handleUpdateDocumentType = function (doc, documentType) {
        return api.base
            .put("".concat(config.appUrls.documents, "/api/documents/type"), { id: doc.id, documentType: documentType })
            .then(function () {
            if (documents.some(function (x) { return x.id === doc.id; })) {
                onDocumentsChanged(documents.map(function (x) { return (x.id !== doc.id ? x : __assign(__assign({}, x), { documentType: documentType })); }));
            }
            else {
                setNewDocuments(function (prev) { return prev.map(function (x) { return (x.id !== doc.id ? x : __assign(__assign({}, x), { documentType: documentType })); }); });
            }
            ToastrService.success();
        })
            .catch(handleHttpError(intl));
    };
    var uploadEndpoint = linkId
        ? "".concat(config.appUrls.documents, "/api/documents?documentType=-1&documentLinkType=").concat(linkType, "&linkId=").concat(linkId, "&relationId=").concat(relationId)
        : "".concat(config.appUrls.documents, "/api/documents?documentType=-1&relationId=").concat(relationId);
    return (_jsxs("div", __assign({ className: "form-horizontal" }, { children: [previewDocumentId && (_jsx(DocumentDetailsModal, { documentId: previewDocumentId, show: true, onClose: function () { return setPreviewDocumentId(null); }, onSave: handleDocumentPreviewSaved })), _jsxs("div", __assign({ className: "form-group" }, { children: [_jsx("div", __assign({ className: "col-md-4" }, { children: _jsx("label", __assign({ className: "control-label" }, { children: intl.formatMessage(messages.Documents) })) })), _jsx("div", __assign({ className: "col-md-8" }, { children: !readOnly && (_jsx("div", __assign({ className: "margin10B" }, { children: _jsxs(CanCreate, __assign({ on: "Documents" }, { children: [_jsx("div", __assign({ className: "file-upload-wrapper margin5B" }, { children: _jsx(FileUpload, { endpoint: uploadEndpoint, relationId: relationId, onFileUploaded: handleFileUploaded, removeSuccessfullAfter: 500 }) })), _jsxs(Button, __assign({ btnClassName: "btn btn-default btn-grey btn-sm btn-block", onClick: function () { return setShowDocumentSelector(true); } }, { children: [_jsx(FaRegFolderOpen, { className: "react-icon margin5R" }), intl.formatMessage(messages.ChooseDocumentInAdminPulse)] }))] })) }))) }))] })), (documents.length > 0 || newDocuments.length > 0) && (_jsxs("table", __assign({ className: "table margin10B" }, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", {}), linkId && _jsx("th", { children: intl.formatMessage(messages.DocumentDate) }), _jsx("th", { children: intl.formatMessage(messages.DocumentType) }), _jsx("th", { children: intl.formatMessage(messages.Name) }), _jsx("th", {})] }) }), _jsxs("tbody", { children: [documents.map(function (doc) { return (_jsxs("tr", { children: [_jsx("td", { children: doc.showSpinner && _jsx("i", { className: "fa fa-spinner fa-spin" }) }), linkId && (_jsx("td", __assign({ style: { maxWidth: 100 } }, { children: _jsx(FormattedDateShort, { value: doc.documentDate }) }))), _jsx("td", __assign({ style: { maxWidth: 100 } }, { children: doc.recognitionStatus === 1 || doc.recognitionStatus === 3 ? (_jsx("span", __assign({ className: "label label-info label-striped active" }, { children: _jsx(FormattedListValue, { list: "recognitionStatus", id: doc.recognitionStatus }) }))) : (_jsx(CanUpdate, __assign({ on: "Documents" }, { children: _jsx(EditableDocumentTypeSelect, { value: doc.documentType, onChange: function (type) { return handleUpdateDocumentType(doc, type); }, required: true, disabled: readOnly }) }))) })), _jsx("td", { children: canReadDocs && doc.scanStatus === 2 ? (_jsxs("a", __assign({ onClick: function () { return setPreviewDocumentId(doc.id); }, title: intl.formatMessage(messages.OpenDocument) }, { children: [_jsx(FileIcon, { document: doc }), doc.name] }))) : (_jsxs("span", { children: [_jsx(FileIcon, { document: doc }), doc.name] })) }), _jsxs("td", __assign({ className: "text-nowrap" }, { children: [canExtractAI &&
                                                doc.recognitionStatus !== 1 &&
                                                doc.recognitionStatus !== 3 &&
                                                DocumentService.supportsDataExtraction(doc.documentType) && (_jsx("span", { children: extractingDocumentId === doc.id ? (_jsx("i", { className: "fa fa-spinner fa-spin margin5R" })) : (_jsx("i", { onClick: function () { return onExtractDocument(doc.id); }, title: intl.formatMessage(messages.ExtractDocumentData), className: "fa fa-magic clickable margin5R" })) })), !readOnly && (_jsx(CanDelete, __assign({ on: "Documents" }, { children: _jsx("i", { onClick: function () { return setDeleteTarget({ document: doc, isNew: false }); }, title: intl.formatMessage(messages.Delete), className: "fa fa-trash-o clickable" }) })))] }))] }, doc.id)); }), newDocuments.map(function (doc, idx) { return (_jsxs("tr", { children: [_jsx("td", { children: doc.showSpinner && _jsx("i", { className: "fa fa-spinner fa-spin" }) }), linkId && _jsx("td", {}), _jsx("td", __assign({ style: { maxWidth: 100 } }, { children: doc.recognitionStatus === 1 || doc.recognitionStatus === 3 ? (_jsx("span", __assign({ className: "label label-info label-striped active" }, { children: _jsx(FormattedListValue, { list: "recognitionStatus", id: doc.recognitionStatus }) }))) : (_jsx(CanUpdate, __assign({ on: "Documents" }, { children: _jsx(EditableDocumentTypeSelect, { value: doc.documentType, onChange: function (type) { return handleUpdateDocumentType(doc, type); }, required: true, disabled: readOnly }) }))) })), _jsx("td", { children: canReadDocs && doc.scanStatus === 2 ? (_jsxs("a", __assign({ onClick: function () { return setPreviewDocumentId(doc.id); }, title: intl.formatMessage(messages.OpenDocument) }, { children: [_jsx(FileIcon, { document: doc }), doc.name] }))) : (_jsxs("span", { children: [_jsx(FileIcon, { document: doc }), doc.name] })) }), _jsxs("td", __assign({ className: "text-nowrap" }, { children: [canExtractAI &&
                                                doc.recognitionStatus !== 1 &&
                                                doc.recognitionStatus !== 3 &&
                                                DocumentService.supportsDataExtraction(doc.documentType) && (_jsx("span", { children: extractingDocumentId === doc.id ? (_jsx("i", { className: "fa fa-spinner fa-spin margin5R" })) : (_jsx("i", { onClick: function () { return onExtractDocument(doc.id); }, title: intl.formatMessage(messages.ExtractDocumentData), className: "fa fa-magic clickable margin5R" })) })), !readOnly && (_jsx("i", { onClick: function () { return handleDeleteNewDocument(doc); }, title: intl.formatMessage(messages.Delete), className: "fa fa-trash-o clickable" }))] }))] }, "new-".concat(idx))); })] })] }))), showDocumentSelector && (_jsx(DocumentSelectorModal, { show: true, initialRelation: relationId, initialSelectedDocuments: documents, onDocumentsSelected: handleDocumentsSelected, onClose: function () { return setShowDocumentSelector(false); } })), deleteTarget && !deleteTarget.isNew && (_jsx(YesNoCancelModal, { show: true, title: intl.formatMessage(messages.ConfirmDeleteTitle), message: intl.formatMessage(messages.ConfirmDeleteDocumentOrLink), onCancel: function () { return setDeleteTarget(null); }, onNo: function () { return handleDeleteExistingDocument(deleteTarget.document, false); }, onYes: function () { return handleDeleteExistingDocument(deleteTarget.document, true); } }))] })));
};
export default FiscalDocumentList;
